/**
 * @author        esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   MapBox Module Actions
 */

import type { BoundsObj } from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import { createAction } from 'redux-actions'
import {
  DISABLE_SYNC,
  DISABLE_SYNC_ON_MOVE,
  ENABLE_SYNC,
  ENABLE_SYNC_ON_MOVE,
  FREEZE_ZOOM,
  HIDE,
  MOUNT,
  NOT_READY,
  READY,
  RESET_CENTER,
  RESET_META,
  SHOW,
  SYNC,
  THAW_ZOOM,
  UNMOUNT,
  UNSYNC,
  UPDATE_BEARING,
  UPDATE_BOX,
  UPDATE_CENTER,
  UPDATE_DIMENSIONS,
  UPDATE_HEIGHT,
  UPDATE_LATITUDE,
  UPDATE_LONGITUDE,
  UPDATE_PITCH,
  UPDATE_WIDTH,
  UPDATE_ZOOM,
} from '../constants'

export const updateWidth = createAction<number | null, typeof UPDATE_WIDTH>(UPDATE_WIDTH)
export const updateHeight = createAction<number | null, typeof UPDATE_HEIGHT>(UPDATE_HEIGHT)
export const updateDimensions = createAction<
  { height: number; width: number },
  typeof UPDATE_DIMENSIONS
>(UPDATE_DIMENSIONS)

export const resetCenter = createAction(RESET_CENTER)
export const updateCenter = createAction<{ lat: number; lng: number }, typeof UPDATE_CENTER>(
  UPDATE_CENTER
)
export const updateLatitude = createAction<number | undefined, typeof UPDATE_LATITUDE>(
  UPDATE_LATITUDE
)
export const updateLongitude = createAction<number | undefined, typeof UPDATE_LONGITUDE>(
  UPDATE_LONGITUDE
)

export const updateZoom = createAction<number | undefined, typeof UPDATE_ZOOM>(UPDATE_ZOOM)

export const updateBearing = createAction<number | undefined, typeof UPDATE_BEARING>(UPDATE_BEARING)
export const updatePitch = createAction<number | undefined, typeof UPDATE_PITCH>(UPDATE_PITCH)
export const updateBox = createAction<MaybeEmpty<BoundsObj> | null, typeof UPDATE_BOX>(UPDATE_BOX)

export const ready = createAction(READY)
export const notReady = createAction(NOT_READY)

export const mount = createAction(MOUNT)
export const unmount = createAction(UNMOUNT)

export const freezeZoom = createAction<number, typeof FREEZE_ZOOM>(FREEZE_ZOOM)
export const thawZoom = createAction(THAW_ZOOM)

export const enableSyncOnMove = createAction(ENABLE_SYNC_ON_MOVE)
export const disableSyncOnMove = createAction(DISABLE_SYNC_ON_MOVE)

export const sync = createAction(SYNC)
export const unsync = createAction(UNSYNC)

export const enableSync = createAction(ENABLE_SYNC)
export const disableSync = createAction(DISABLE_SYNC)

export const show = createAction(SHOW)
export const hide = createAction(HIDE)

export const resetMeta = createAction(RESET_META)
